import React, { useContext, useEffect, useState } from "react";
import { GlobalContext } from "../../../../contexts/GlobalContext";
import { getDataCronDebug } from "../../../../hooks/api/apiDebug";
import DataCronDebug from "./DataCronDebug";
import './apiDebug.css';

export default function ViewCronDebug() {
  const globalContext = useContext(GlobalContext);
  const [inputCode, setInputCode] = useState("");
  const [datosApi, setDatosApi] = useState([]);
  const [loading, setLoading] = useState(false);
  const [paginaActual, setPaginaActual] = useState(1);
  const [totalPage, setTotalPage] = useState(null);
  const [totalRegistros, setTotalRegistros] = useState(0);
  const [error, setError] = useState(null);

  const obtenerDatos = async (pagina = 1) => {
    if (!inputCode.trim()) {
      setError("Por favor ingresa un código de proceso");
      return;
    }

    setDatosApi([]);
    setLoading(true);
    setError(null);

    const parametros = {
      page: pagina,
      limit: 10,
    };

    try {
      const respuesta = await getDataCronDebug(inputCode, parametros);
      const nuevosDatos = respuesta.data?.data?.results || respuesta.data || [];
      const total = respuesta.data?.data?.total || 0;
      const totalPages = Math.ceil(total / parametros.limit);
      
      setTotalPage(totalPages);
      setTotalRegistros(total);
      setDatosApi(nuevosDatos);
      
      if (nuevosDatos.length === 0) {
        setError("No se encontraron registros para el código ingresado");
      }
    } catch (error) {
      console.error("Error en la API:", error);
      setError(error.response?.data?.message || "Error al obtener los datos. Verifica el código ingresado.");
      setDatosApi([]);
    } finally {
      setLoading(false);
    }
  };

  const handleSiguiente = (direccion) => {
    let nuevaPagina = paginaActual;
    if (direccion === "back") {
      nuevaPagina = Math.max(1, paginaActual - 1);
    } else {
      nuevaPagina = Math.min(totalPage, paginaActual + 1);
    }

    setPaginaActual(nuevaPagina);
    obtenerDatos(nuevaPagina);
  };

  const handleBuscar = () => {
    setPaginaActual(1);
    obtenerDatos(1);
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleBuscar();
    }
  };

  useEffect(() => {
    // obtenerDatos(paginaActual);
  }, [globalContext.empresaActualId]);

  return (
    <div className="cron-debug-container">
      <div className="cron-debug-header">
        <h1 className="cron-debug-title">
          Consultas para <strong>Debug Cron</strong>
        </h1>
        <p className="cron-debug-subtitle">
          Ingresa un <strong>CODE PROCESS</strong> para consultar los registros del process monitor
        </p>
      </div>

      <div className="cron-debug-search-section">
        <div className="search-container">
          <div className="search-input-group">
            <label htmlFor="code-input" className="search-label">
              CODE PROCESS
            </label>
            <input
              id="code-input"
              className="search-input"
              type="text"
              value={inputCode}
              onChange={(e) => setInputCode(e.target.value)}
              onKeyPress={handleKeyPress}
              placeholder="Ej: ODOO_SYNC_PRODUCTS_CRON"
              disabled={loading}
            />
          </div>
          <button
            className="search-button"
            onClick={handleBuscar}
            disabled={loading || !inputCode.trim()}
          >
            {loading ? 'Buscando...' : '🔍 Buscar'}
          </button>
        </div>

        {/* Información de paginación */}
        {totalRegistros > 0 && (
          <div className="pagination-info">
            <span>
              Mostrando página <strong>{paginaActual}</strong> de <strong>{totalPage}</strong>
            </span>
            <span className="total-registros">
              Total: <strong>{totalRegistros}</strong> registro{totalRegistros !== 1 ? 's' : ''}
            </span>
          </div>
        )}

        {/* Controles de paginación */}
        {totalPage > 1 && (
          <div className="pagination-controls">
            <button
              className="pagination-btn"
              onClick={() => handleSiguiente("back")}
              disabled={paginaActual === 1 || loading}
            >
              ← Anterior
            </button>
            <span className="pagination-indicator">
              {paginaActual} / {totalPage}
            </span>
            <button
              className="pagination-btn"
              onClick={() => handleSiguiente("next")}
              disabled={paginaActual >= totalPage || loading}
            >
              Siguiente →
            </button>
          </div>
        )}
      </div>

      {/* Mensajes de error */}
      {error && (
        <div className="error-message">
          <span className="error-icon">⚠️</span>
          <span>{error}</span>
        </div>
      )}

      {/* Contenido de resultados */}
      <div className="cron-debug-results">
        {loading ? (
          <div className="loading-container">
            <div className="loader"></div>
            <p className="loading-text">Cargando registros...</p>
          </div>
        ) : datosApi && datosApi.length > 0 ? (
          <div className="results-list">
            {datosApi.map((item, index) => (
              <DataCronDebug 
                key={item._id || index} 
                data={item} 
                index={index + (paginaActual - 1) * 10}
              />
            ))}
          </div>
        ) : !error && inputCode ? (
          <div className="no-results">
            <p>No se encontraron registros para el código ingresado</p>
          </div>
        ) : null}
      </div>
    </div>
  );
}
